var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"line bg-color-c8 mb-4",staticStyle:{"margin":"auto"},style:({width: _vm.open ? _vm.openWidth : _vm.closeWidth, transition: _vm.transitionTime + ' all'})})
}
var staticRenderFns = []

export { render, staticRenderFns }